import { NumberInput } from '@presentation/components/molecules'
import { NumberInputProps } from '@presentation/types/components/molecules'

const DescriptionNumberInput: React.FC<NumberInputProps> = props => {
  return <NumberInput {...props} required />
}

export default DescriptionNumberInput
